import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import { isUndef } from '@/lib/utils';
import EquipmentGift from '@/models/equipmentGift';

var UserInfo =
/** @class */
function () {
  function UserInfo(info) {
    this.name = info.name;
    this.gender = info.gender;
    this.age = info.age;
    this.mobile = info.mobile;
    this.district = info.district;
    this.address = info.address;
    this.can_change_address = info.can_change_address;
    this.can_change_before = info.can_change_before;
    this.gifts = info.gifts.map(function (gift) {
      return new EquipmentGift(gift);
    });
    this.change_spec_days = info.change_spec_days;
    this.lettering = info.lettering;
    this.change_count = info.change_count;
  }
  /**
   * 是否存在可以修改的情况
   * todo: 感觉这个没有什么用
   */


  UserInfo.prototype.canModify = function () {
    var canModify = isUndef(this.can_change_address) ? false : this.can_change_address;

    if (this && this.gifts) {
      this.gifts.forEach(function (gift) {
        if (gift.can_change === true) {
          canModify = true;
        }
      });
    }

    return canModify;
  };

  return UserInfo;
}();

var m = {
  namespaced: true,
  state: function state() {
    return {
      userInfo: {},
      giftMap: {},
      tempEquipmentAddress: null,
      isBinder: {},
      SpecialId: ''
    };
  },
  mutations: {
    /**
     * 记录用户信息
     */
    setUserInfo: function setUserInfo(state, _a) {
      var activityId = _a.activityId,
          userInfo = _a.userInfo;
      Vue.set(state.userInfo, activityId, userInfo);
      userInfo.gifts.forEach(function (gift) {
        Vue.set(state.giftMap, gift.id, gift);
      });
    },
    // 是否是帮报名
    isBinder: function isBinder(state, data) {
      state.isBinder = data;
    },
    setTempEquipmentAddress: function setTempEquipmentAddress(state, id) {
      console.log('target eqAddress 1-1', id);
      state.tempEquipmentAddress = id;
    },
    SpecialId: function SpecialId(state, data) {
      state.SpecialId = data;
    }
  },
  actions: {
    /**
     * 获取用户信息
     *
     * @param {} forceUpdate 是否强制更新
     *
     * @return {} userInfo返回userInfo信息
     */
    getUserInfo: function getUserInfo(_a, _b) {
      var state = _a.state,
          dispatch = _a.dispatch,
          commit = _a.commit;
      var activityId = _b.activityId,
          orderId = _b.orderId,
          _c = _b.forceUpdate,
          forceUpdate = _c === void 0 ? false : _c;
      return __awaiter(this, void 0, void 0, function () {
        var userInfo, response, rdata, info;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              userInfo = state.userInfo[activityId];

              if (userInfo && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              if (forceUpdate) {
                state.userInfo[activityId] = undefined;
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/gift/user_info', {
                params: {
                  activity_id: activityId,
                  order_id: orderId
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                info = rdata.data;

                if (isUndef(info)) {
                  return [2
                  /*return*/
                  ];
                }

                info.district = [info.district_1_id, info.district_2_id, info.district_3_id].filter(function (_) {
                  return _;
                });
                delete info.district_1_id;
                delete info.district_2_id;
                delete info.district_3_id;
                commit('setUserInfo', {
                  activityId: activityId,
                  userInfo: new UserInfo(rdata.data)
                });
                commit('isBinder', rdata.data);
              }

              return [2
              /*return*/
              ];
          }
        });
      });
    },

    /**
     * 更新userInfo
     *
     * @param {} userInfo 所有的userInfo，允许传入null以覆盖值
     *  - name
     *  - gender
     *  - age
     *  - mobile
     *  - districtLevel1
     *  - districtLevel2
     *  - districtLevel3
     *  - addressDetail
     *  - clothesSize
     *  - app
     *  - knowFrom
     *  - shoeSize
     *
     * @return {} rdata，完整的JSON响应内容
     */
    updateUserInfo: function updateUserInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId,
          name = _b.name,
          mobile = _b.mobile,
          district = _b.district,
          address = _b.address,
          orderId = _b.orderId,
          specifications = _b.specifications,
          optional_specifications = _b.optional_specifications,
          invite_specifications = _b.invite_specifications,
          lettering = _b.lettering,
          blind_box_specifications = _b.blind_box_specifications;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/gift/user_info', {
                activity_id: activityId,
                name: name,
                age: '0',
                // gender: userInfo.gender,
                mobile: mobile,
                district_1_id: district === null || district === void 0 ? void 0 : district[0],
                district_2_id: district === null || district === void 0 ? void 0 : district[1],
                district_3_id: district === null || district === void 0 ? void 0 : district[2],
                address: address,
                specifications: specifications,
                optional_specifications: optional_specifications,
                invite_specifications: invite_specifications,
                order_id: orderId,
                lettering: lettering,
                blind_box_specifications: blind_box_specifications
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;